// Firebase v9+ Modular SDK

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "AIzaSyCZKmWkBF0YYR9SrFunCYucLXhfZP110Xo",
//   authDomain: "vivashri-fbc37.firebaseapp.com",
//   projectId: "vivashri-fbc37",
//   storageBucket: "vivashri-fbc37.firebasestorage.app",
//   messagingSenderId: "634079829178",
//   appId: "1:634079829178:web:d42bf4107eec0166c07683",
//   measurementId: "G-G9M0WQR1SS"
// };

const firebaseConfig = {
  apiKey: "AIzaSyB2HcrxczBQ0RH3i5dbh1uws2vR7HJ8od4",
  authDomain: "vivashri-6774d.firebaseapp.com",
  projectId: "vivashri-6774d",
  storageBucket: "vivashri-6774d.firebasestorage.app",
  messagingSenderId: "916653873249",
  appId: "1:916653873249:web:6f6d6b4949fdfac7453220",
  measurementId: "G-G9M0WQR1SS"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);
